import { Form, Modal, Select, Input } from 'antd';

interface ActionAfterFailurePopupProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (values: { action_after_failure: string; msg?: string; comment_for?: string }) => void;
  options: {
    label: string;
    value: string;
  }[];
  isLoading?: boolean;
}

const ActionAfterFailurePopup: React.FC<ActionAfterFailurePopupProps> = ({
  visible,
  onClose,
  onSubmit,
  options,
  isLoading = false,
}) => {
  const [form] = Form.useForm();

  return (
    <Modal
      title="Failure Action"
      open={visible}
      onOk={() => form.submit()}
      confirmLoading={isLoading}
      onCancel={onClose}
    >
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          name="action_after_failure"
          label="Action After Failure"
          rules={[{ required: true, message: 'Please select an action' }]}
        >
          <Select placeholder="Select Action">
            {options.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="comment_for" label="Comment For">
          <Select allowClear placeholder="Select">
            <Select.Option value="CUSTOMER">Customer</Select.Option>
            <Select.Option value="USER">System Admin</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name="msg" label="Message">
          <Input.TextArea placeholder="Enter message" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ActionAfterFailurePopup;
